import styled from 'styled-components';

const VolumeSeekerStyled = styled.div`
  position: relative;
`;

export default VolumeSeekerStyled;
